module.exports = __webpack_public_path__ + "static/img/khk002a.5df28beb.jpg";